import React from 'react';

const Quote = () => (
  <section className="quote-content">
    <div className="quote-header">
      <h1>Quote of the Day</h1>
    </div>
    <div className="text-container">
      <p className="text-content">
        Life is a math equation. In order to gain the most, you have to know how to convert
        negatives into positives.
      </p>
      <p className="text-content">
        <strong>
          <em>
            — Anonymous
          </em>
        </strong>
      </p>
    </div>
  </section>
);

export default Quote;
